(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bbm-private-inquiry"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-bbm-inquiry]').forEach((container) => {
        if (container.dataset.ready) return;
        container.dataset.ready = 'true';
        const params = new URLSearchParams(window.location.search);
        const reference = container.querySelector('[data-inquiry-reference]');
        const category = container.querySelector('[data-inquiry-category]');
        const source = container.querySelector('[data-inquiry-source]');
        if (reference && !reference.value) reference.value = (params.get('reference') || params.get('style') || '').slice(0, 200);
        if (category) {
          const proposed = params.get('category');
          if ([...category.options].some((option) => option.value === proposed)) category.value = proposed;
        }
        if (source && params.get('style_url')) {
          try {
            const url = new URL(params.get('style_url'), window.location.origin);
            if (url.origin === window.location.origin && /^https?:$/.test(url.protocol)) {
              url.search = '';
              url.hash = '';
              source.value = url.href.slice(0, 1500);
              container.querySelector('[data-inquiry-source-wrapper]').hidden = false;
            }
          } catch {}
        }
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
    else initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-b2b-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-process-carousel]').forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll('[data-process-slide]'));
    const tabs = Array.from(carousel.querySelectorAll('[data-process-go]'));
    const previous = carousel.querySelector('[data-process-prev]');
    const next = carousel.querySelector('[data-process-next]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let activeIndex = 0;
    let timer;

    const stopRotation = () => window.clearInterval(timer);
    const startRotation = () => {
      stopRotation();
      if (reducedMotion) return;
      timer = window.setInterval(() => {
        const video = slides[activeIndex].querySelector('video');
        if (video.paused) showSlide(activeIndex + 1);
      }, 8000);
    };
    const showSlide = (requestedIndex) => {
      slides[activeIndex].querySelector('video').pause();
      activeIndex = (requestedIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const selected = index === activeIndex;
        slide.classList.toggle('is-active', selected);
        slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
        tabs[index].classList.toggle('is-active', selected);
        tabs[index].setAttribute('aria-selected', selected ? 'true' : 'false');
      });
    };

    tabs.forEach((tab) => tab.addEventListener('click', () => {
      showSlide(Number(tab.dataset.processGo));
      startRotation();
    }));
    previous.addEventListener('click', () => {
      showSlide(activeIndex - 1);
      startRotation();
    });
    next.addEventListener('click', () => {
      showSlide(activeIndex + 1);
      startRotation();
    });
    slides.forEach((slide) => {
      const video = slide.querySelector('video');
      video.addEventListener('play', stopRotation);
      video.addEventListener('ended', startRotation);
    });
    carousel.addEventListener('pointerenter', stopRotation);
    carousel.addEventListener('pointerleave', startRotation);
    carousel.addEventListener('focusin', stopRotation);
    carousel.addEventListener('focusout', () => window.setTimeout(() => {
      if (!carousel.contains(document.activeElement)) startRotation();
    }, 0));
    startRotation();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
